<template>
    <v-container fluid>
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="10"
                lg="9"
                xl="7"
                class="d-flex flex-row flex-wrap justify-space-between align-center"
            >
                <h1 class="platformName">
                    {{ userDashboardTitle }}
                </h1>
                <p class="platformSubtitle">
                    {{ userDashboardSubtitle }}
                </p>
            </v-col>
        </v-row>

        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="10"
                lg="9"
                xl="7"
                class="d-flex flex-row flex-wrap justify-space-between align-center"
            >
                <v-alert
                    style="width: 100%"
                    type="info"
                    color="primary"
                    v-if="userDashboardNotification"
                >
                    {{ userDashboardNotification }}
                </v-alert>

                <v-card
                    class="DashboardCard"
                    v-if="userDashboardWelcomeVideoEmbed"
                >
                    <v-card-text>
                        <div class="DashboardVideo">
                            <div class="DashboardVideo__iFrameWrapper">
                                <div class="DashboardVideo__iFrame">
                                    <div
                                        :class="{jsVideoLoaded:!videoOverlay}"
                                        class="WistiaOverlay"
                                    >
                                        <v-progress-circular
                                            color="primary"
                                            indeterminate
                                        />
                                    </div>
                                    <iframe
                                        :onload="iframeLoaded()"
                                        :src="'https://fast.wistia.net/embed/iframe/' + userDashboardWelcomeVideoEmbed"
                                    />
                                </div>
                            </div>
                        </div>

                        <div
                            class="DashboardWelcomeText"
                            v-html="userDashboardWelcomeText"
                        />
                        <v-select
                            :items="professions"
                            item-text="name"
                            item-value="id"
                            name="profession"
                            id="profession"
                            :label="professionFieldLabel"
                            v-model="selectedProfession"
                            @change="initChangeProfession"
                            outlined
                            :loading="loading"
                            clearable
                            placeholder="No Starter Content"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-model="professionModal"
            max-width="500"
        >
            <v-card>
                <v-card-title>
                    {{ professionNotificationTitle }}
                </v-card-title>
                <v-card-text>
                    {{ professionNotificationText }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="closeModalAndResetProfession()"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="changeProfession"
                    >
                        <v-icon
                            small
                            left
                        >
                            fas fa-save
                        </v-icon>
                        Change
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from 'axios';
import notify from '@/store/Common/notify';
import store from '@/store/store';

export default {

    data() {
        return {
            selectedProfession: undefined,
            originalProfession: false,
            professions: [],
            loading: true,
            professionModal: false,
            videoOverlay: true
        };
    },
    computed: {
        professionFieldLabel() {
            if (store.state.settings.settings['settingProfession']) {
                return store.state.settings.settings['settingProfession'].professionFieldLabel;
            } else {
                return '';
            }
        },

        professionNotificationText() {
            if (store.state.settings.settings['settingProfession']) {
                return store.state.settings.settings['settingProfession'].professionNotificationText;
            } else {
                return '';
            }
        },

        professionNotificationTitle() {
            if (store.state.settings.settings['settingProfession']) {
                return store.state.settings.settings['settingProfession'].professionNotificationTitle;
            } else {
                return '';
            }
        },

        userDashboardWelcomeVideoEmbed() {
            if (store.state.settings.settings['settingDashboardUser']) {
                return store.state.settings.settings['settingDashboardUser'].userDashboardWelcomeVideoEmbed;
            } else {
                return '';
            }
        },

        userDashboardWelcomeText() {
            if (store.state.settings.settings['settingDashboardUser']) {
                return store.state.settings.settings['settingDashboardUser'].userDashboardWelcomeText;
            } else {
                return '';
            }
        },

        userDashboardSubtitle() {
            if (store.state.settings.settings['settingDashboardUser']) {
                return store.state.settings.settings['settingDashboardUser'].userDashboardSubtitle;
            } else {
                return '';
            }
        },

        userDashboardTitle() {
            if (store.state.settings.settings['settingDashboardUser']) {
                return store.state.settings.settings['settingDashboardUser'].userDashboardTitle;
            } else {
                return '';
            }
        },

        userDashboardNotification() {
            if (store.state.settings.settings['settingDashboardUser']) {
                return store.state.settings.settings['settingDashboardUser'].userDashboardNotification;
            } else {
                return '';
            }
        }
    },

    mounted() {
        this.getUserProfession()
            .then(() => {
                this.getProfessionList();
            });
    },

    methods: {
        clearProfession() {
            this.selectedProfession = undefined;
            this.originalProfession = undefined;
        },

        closeModalAndResetProfession() {
            this.professionModal = false;
            this.selectedProfession = this.originalProfession;
        },

        getProfessionList() {
            this.loading = true;
            axios.get('/api/specialty/index')
                .then(response => {
                    this.professions = response.data.data.professions;
                    this.loading = false;
                });
        },

        initChangeProfession() {
            if (this.originalProfession) {
                this.professionModal = true;
            } else {
                this.changeProfession();
            }
        },

        changeProfession() {
            let profession = null;
            this.professionModal = false;
            if (this.selectedProfession) {
                profession = this.selectedProfession;
            }
            axios.post('/api/user/profession', { 'id': profession })
                .then(() => {
                    this.originalProfession = this.selectedProfession;
                    notify('Starter content updated successfully', 'success');
                });
        },

        getUserProfession() {
            return new Promise(resolve => {
                axios.get('/api/user/profession')
                    .then(response => {
                        if (response.data.profession) {
                            this.selectedProfession = response.data.profession;
                            this.originalProfession = response.data.profession;
                            resolve();
                        } else {
                            this.selectedProfession = undefined;
                            resolve();
                        }
                    })
                    .catch(() => {
                        this.selectedProfession = undefined;
                        resolve();
                    });
            });
        },

        iframeLoaded() {
            setTimeout(() => {
                this.videoOverlay = false;
            }, 1000);
        }
    }
};
</script>
<style lang="scss">
.DashboardCard {
    flex: 0 0 100%;
    width: 100%;

    @media (min-width: 768px) {
        padding: 24px;
    }

    @media (min-width: 1200px) {
        padding: 48px;
    }

    .v-input__control {
        margin-bottom: 0;
    }

    .v-text-field__details, {
        display: none !important;
    }
}

.DashboardVideo {
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 24px;
}

.DashboardVideo__iFrameWrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 56.25%;
}

.DashboardVideo__iFrame {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    iframe {
        width: 100%;
        height: 100%;
        border: 0 none;
        z-index: 2;
    }
}

.WistiaOverlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    background-color: white;
    opacity: 1;
    z-index: 3;
    pointer-events: none;
    transition: opacity 0.2s linear;

    &.jsVideoLoaded {
        opacity: 0;
        z-index: 1;
        pointer-events: none;
        transition: opacity 0.2s linear;
    }
}

.DashboardWelcomeText {
    flex: 0 0 100%;
    width: 100%;
    margin-bottom: 24px;
    font-size: 1.02rem;
}

</style>
